/**
   * 费用统计/显示字段,模型
   * 使用说明：
   * @param fieldName 需要显示的名称
   * @param countField 需要统计的字段名
   * @param currencyField 币种字段名,如果要做折合，则需要填写币种字段名（只给合计区使用，即不会在详情显示窗口中显示）
   * @param rateField 汇率字段名，如果要做折合，则需要填写汇率字段名（只给合计区使用，即不会在详情显示窗口中显示）
   * @param inGrid 是否在详情中显示
   * @param dataAdapters 数据过滤器，即符合条件的数据才会被统计
   */

export default class ChargeCountField {
  constructor(fieldName, countField, currencyField, rateField, inGrid, dataAdapters) {
    this._fieldName = fieldName // 统计显示名
    this._countField = countField // 统计字段名
    this._currencyField = currencyField // 原始币种的字段字段名
    this._rateField = rateField // 原始汇率的字段名
    this._inGrid = inGrid
    this._dataAdapters = dataAdapters // 忽略的字段
  }

  get fieldName() {
    return this._fieldName
  }

  set fieldName(value) {
    this._fieldName = value
  }

  get countField() {
    return this._countField
  }

  set countField(value) {
    this._countField = value
  }

  get currencyField() {
    return this._currencyField
  }

  set currencyField(value) {
    this._currencyField = value
  }

  get rateField() {
    return this._rateField
  }

  set rateField(value) {
    this._rateField = value
  }

  get inGrid() {
    return this._inGrid
  }

  set inGrid(value) {
    this._inGrid = value
  }

  get dataAdapters() {
    return this._dataAdapters
  }

  set dataAdapters(value) {
    this._dataAdapters = value
  }
}
